module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "visa.249f46d7.png";